import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/SearchAddress'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class SearchAddressStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "SearchAddressStore",
			variables: true,
		})
	}
}

export async function load_SearchAddress(params) {
  await initClient()

	const store = new SearchAddressStore()

	await store.fetch(params)

	return {
		SearchAddress: store,
	}
}
